import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import { DriverTask } from 'src/app/classes/driver-task';
import { Passenger } from 'src/app/classes/passenger';


export interface DialogData {
  driverTask: DriverTask;
}

@Component({
  standalone: false,
  selector: 'app-confirm-passenger-not-checked-in-dialog',
  templateUrl: './confirm-passenger-not-checked-in-dialog.component.html',
  styleUrls: ['./confirm-passenger-not-checked-in-dialog.component.scss']
})
export class ConfirmPassengerNotCheckedInDialogComponent implements OnInit {
  passengersNotCheckedIn: Array<Passenger> = [];
  warningIcon = faExclamationTriangle as IconProp;
  constructor(
    public dialogRef: MatDialogRef<ConfirmPassengerNotCheckedInDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    this.passengersNotCheckedIn = this.data.driverTask.passengers.filter(passenger => passenger.checkedIn === false)
  }

}
